import * as Sentry from "@sentry/react";
import { useEffect, type ReactNode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import { initSentry } from "./lib/sentry";

initSentry();

const root = document.getElementById("root")!;
function Ready({ children }: { children: ReactNode }) {
  useEffect(() => { root.dataset.hydrated = "true"; }, []);
  return children;
}
if (root.dataset.prerender === "php2shell" && window.location.pathname === "/php2shell") {
  // Preserve the already painted campaign instead of clearing it for a loading shell.
  Promise.all([import("./pages/Php2Shell"), import("./components/CookieConsent")]).then(([{ default: Campaign }, { CookieConsent }]) => {
    hydrateRoot(root, <Ready><Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}><Campaign /><CookieConsent /></Sentry.ErrorBoundary></Ready>);
  });
} else {
  import("./App.tsx").then(({ default: App }) => {
    const app = <Ready><Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}><App /></Sentry.ErrorBoundary></Ready>;
    if (root.dataset.prerender === "home" && window.location.pathname === "/") hydrateRoot(root, app);
    else createRoot(root).render(app);
  });
}
